import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BackendDataShape, UsedAPI } from "api/config";
import CookieMonster from "api/CookieMonster";

export const evaluationTypeStoreAPI = createApi({
  reducerPath: "evaluationTypeStoreAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${UsedAPI}`,
    prepareHeaders: (headers) => {
      let token = CookieMonster.loadCookie("jwt");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["EvaluationTypeList"],
  endpoints: (builder) => {
    return {
      getEvaluationType: builder.query<string[], object>({
        query: () => {
          let url = "/master-evaluation/evaluation-type";
          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (response: BackendDataShape<string[]>) =>
          response.data,
        providesTags: ["EvaluationTypeList"],
      }),
    };
  },
});

export const {
  useGetEvaluationTypeQuery,
  util: { resetApiState: resetEvaluationTypeStoreAPI },
} = evaluationTypeStoreAPI;
